module.exports = __webpack_public_path__ + "media/fonts/stroyka/stroyka-96d355144d4f0826a7e49b7f1ff44e64.svg";